<template>
  <v-layout class="p4-report">
        <div 
            id="packetDialogOverlay">
        </div>
        <div
            style="overflow:auto"
            class="packet"
            id="packetDialog"
        >
            <div class="row header actions">
                <span @click="saveData()" class="save material-icons">save</span>
                <span @click="close()" class="close material-icons">close</span>
            </div>
            <div class="row header">
                <div class="cell">Name</div>
                <div class="cell">Value</div>
                <div class="cell">Description</div>
            </div>
            <div v-for="(row, index) in data" class="row">
                <div class="cell"> {{ row.name }} </div>
                <div class="cell"> 
                    <input 
                        type="text" 
                        :value="row.value" 
                        v-on:blur="edit($event, index)"
                        v-on:keyup.enter="$event.target.blur()"">
                </div>
                <div class="cell"> {{ row.description }} </div>
            </div>
        </div>
  </v-layout>
</template>
<script>
export default {
    name: "PacketDialog",
    props: {
        psClientGuid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            data: [],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            axios
                .get(localConfig.authenticationURL + "/api/clientpacket/" + this.psClientGuid)
                .then(response => {
                    this.data = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        close() {
            this.$emit("input", false);
        },
        edit(event, index) {
            let prevValue = this.data[index].value;
            let newValue = event.target.value;

            if (prevValue !== newValue) {
                event.target.classList.add("changed");
                this.data[index].changed = true;
                this.data[index].value = newValue;
            }
        },
        async saveData() {
            let changedRows =  this.data.filter(d => {
                return d.changed === true;
            });

            if(changedRows.length === 0) {
                return;
            }

            axios
                .post(localConfig.authenticationURL + "/api/clientpacket/" + this.psClientGuid, changedRows)
                .then(response => {
                    alert("Data saved.");
                })
                .catch(error => {
                    alert(error);
                });
        }
    }
};
</script>
<style lang='scss'>
    @import "../styles/PacketDialog.scss";
</style>
